// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"install-desktop"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 22H19M13 4H2V18H22V12.0046","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M16.498 5.49942L19.0006 8.00196L21.5012 5.50127M19.0006 7.25V2.00195","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const InstallDesktopIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'install-desktop',
    ref,
    icon: element,
  },
));

InstallDesktopIcon.displayName = 'InstallDesktopIcon';

export default InstallDesktopIcon;
